import CrossIcon from "@/svg/CrossIcon";
import { css } from "@emotion/react";
import Button from "./Buttons/Button";

interface CloseIconButtonProps {
  iconColor?: string;
  onClose?: () => void;
}

export const CloseIconButton = ({
  iconColor,
  onClose,
  ...props
}: CloseIconButtonProps) => (
  <Button
    type="button"
    jwType="light"
    onClick={onClose}
    css={css`
      background: transparent;
      width: 24px;
      height: 24px;
      min-width: unset;
      border: none;
      padding: 0;
      border-radius: 5px;
      &:hover {
        background: transparent;
      }
    `}
    {...props}
  >
    <CrossIcon
      css={css`
        color: ${iconColor};
        &:hover {
          color: white;
        }
      `}
    />
  </Button>
);

export default CloseIconButton;
